import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=1dd42a14&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Login.scss?vue&type=style&index=0&id=1dd42a14&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd42a14",
  null
  
)

export default component.exports